import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-selection-action-bar',
  standalone: true,
  imports: [],
  template: `
    @if (showBar) {
      <div class="action-bar">
        <!-- Compare 2 Bills Button -->
        @if (selectedBillCount === 2) {
          <button
            (click)="compare.emit()"
            class="action-btn"
            >
            <i class="material-symbols-rounded">compare_arrows</i>
            <span>Compare 2 Bills</span>
          </button>
        }
        <!-- Delete Bills Button (list view, 1+ bills selected) -->
        @if (!isHierarchyView && selectedBillCount >= 1) {
          <button
            (click)="deleteBills.emit()"
            class="action-btn delete-btn"
            >
            <i class="material-symbols-rounded">delete</i>
            <span>Delete {{ selectedBillCount }} {{ selectedBillCount === 1 ? 'Bill' : 'Bills' }}</span>
          </button>
        }
        <!-- Merge Entities Button -->
        @if (isHierarchyView && selectedEntityCount > 1) {
          <button
            (click)="mergeEntities.emit()"
            class="action-btn"
            >
            <i class="material-symbols-rounded">merge</i>
            <span>Merge {{ selectedEntityCount }} Legal {{ selectedEntityCount === 1 ? 'Entity' : 'Entities' }}</span>
          </button>
        }
        <!-- Delete Entities Button -->
        @if (isHierarchyView && selectedEntityCount >= 1) {
          <button
            (click)="deleteEntities.emit()"
            class="action-btn delete-btn"
            >
            <i class="material-symbols-rounded">delete</i>
            <span>Delete {{ selectedEntityCount }} Legal {{ selectedEntityCount === 1 ? 'Entity' : 'Entities' }}</span>
          </button>
        }
        <!-- Merge Addresses Button -->
        @if (isHierarchyView && selectedAddressCount > 1) {
          <button
            (click)="mergeAddresses.emit()"
            class="action-btn"
            >
            <i class="material-symbols-rounded">merge</i>
            <span>Merge {{ selectedAddressCount }} Addresses</span>
          </button>
        }
        <!-- Delete Addresses Button -->
        @if (isHierarchyView && selectedAddressCount >= 1) {
          <button
            (click)="deleteAddresses.emit()"
            class="action-btn delete-btn"
            >
            <i class="material-symbols-rounded">delete</i>
            <span>Delete {{ selectedAddressCount }} {{ selectedAddressCount === 1 ? 'Address' : 'Addresses' }}</span>
          </button>
        }
        <!-- Merge Meters Button -->
        @if (isHierarchyView && selectedMeterCount > 1) {
          <button
            (click)="mergeMeters.emit()"
            class="action-btn"
            >
            <i class="material-symbols-rounded">merge</i>
            <span>Merge {{ selectedMeterCount }} Meters</span>
          </button>
        }
        <!-- Delete Meters Button -->
        @if (isHierarchyView && selectedMeterCount >= 1) {
          <button
            (click)="deleteMeters.emit()"
            class="action-btn delete-btn"
            >
            <i class="material-symbols-rounded">delete</i>
            <span>Delete {{ selectedMeterCount }} {{ selectedMeterCount === 1 ? 'Meter' : 'Meters' }}</span>
          </button>
        }
      </div>
    }
    `,
  styleUrl: './selection-action-bar.component.scss'
})
export class SelectionActionBarComponent {
    @Input() selectedBillCount = 0;
    @Input() selectedEntityCount = 0;
    @Input() selectedAddressCount = 0;
    @Input() selectedMeterCount = 0;
    @Input() isHierarchyView = false;

    @Output() compare = new EventEmitter<void>();
    @Output() deleteBills = new EventEmitter<void>();
    @Output() mergeEntities = new EventEmitter<void>();
    @Output() mergeAddresses = new EventEmitter<void>();
    @Output() deleteEntities = new EventEmitter<void>();
    @Output() deleteAddresses = new EventEmitter<void>();
    @Output() mergeMeters = new EventEmitter<void>();
    @Output() deleteMeters = new EventEmitter<void>();

    get showBar(): boolean {
        return this.selectedBillCount >= 1 ||
               (this.isHierarchyView && (this.selectedEntityCount >= 1 || this.selectedAddressCount >= 1 || this.selectedMeterCount >= 1));
    }
}
